import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { NewCoveringService } from "../../service/new-covering/new-covering.service";
import html2canvas from 'html2canvas';
import jspdf from "jspdf";
import { LoginModel } from "../../login/shared/login.model";
import { PremiData } from "../../service/model/keterangan-kesehatan.model";
import { DownloadDocumentService } from "../../service/download-document/download-document.service";
import { NasabahModel } from "../../service/model/dashboard.model";

@Component({
  selector: 'app-spajk-riplay',
  templateUrl: './spajk-riplay.component.html',
  styleUrls: ['./spajk-riplay.component.css']
})
export class SpajkRiplayComponent implements AfterViewInit {
  dataSpajk: any = {};
  tandaTangan: any;
  dataPribadi: any;
  calculator: any;
  rincianPertanggungan: any;
  @ViewChild('spajkWraper') spajkWrapper!: ElementRef;
  @ViewChild('riplayView') riplayWrapper!: ElementRef;
  documentArray: string[] = []
  isLoading: boolean = true;
  today: Date = new Date()
  marketingChecked: string | null = "";
  loginResponse: LoginModel = {}
  premiData: PremiData = {}
  isSpajkDownloaded: boolean = false;
  isRiplayDownloaded: boolean = false;
  isLoadingSpajk: boolean = false;
  isLoadingRiplay: boolean = false;
  isFromDashboard: boolean = false;
  isFromInsuredSummary: boolean = false;

  // maritalStatus = this.spajk.maritalStatus;
  constructor(private router: Router,
    private newCoveringService: NewCoveringService,
    private documentService: DownloadDocumentService) {

    let background = document.getElementById("background");
    if (background != null) {
      background.className = "allianz-background-faded"
    }
    let jsonDummy = localStorage.getItem('new-business')!
    let jsonTandaTangan = localStorage.getItem('tanda-tangan')!
    let jsonDataPribadi = localStorage.getItem('data-pribadi')!
    let jsonCalculator = localStorage.getItem('calculator')!
    let jsonRincianPertanggungan = localStorage.getItem('rincian-pertanggungan')!
    let jsonLogin = sessionStorage.getItem('login')!
    let jsonNewCoveringResponse = localStorage.getItem('new-covering-response')!

    let jsonPremiData = JSON.parse(JSON.parse(jsonNewCoveringResponse).premiData)
    // let jsonPremiData = {}
    let jsonKontakPribadi = localStorage.getItem('kontak-pribadi')!
    let jsonKontakKantor = localStorage.getItem('kontak-kantor')!
    let jsonSelectedProduk = localStorage.getItem('selected-product')!
    this.marketingChecked = localStorage.getItem('marketing-checked')

    this.dataSpajk = {
      ...JSON.parse(jsonDummy),
      ...JSON.parse(jsonDataPribadi),
      ...JSON.parse(jsonCalculator),
      ...JSON.parse(jsonRincianPertanggungan),
      ...JSON.parse(jsonLogin),
      ...JSON.parse(jsonKontakPribadi),
      ...JSON.parse(jsonKontakKantor),
      ...JSON.parse(jsonSelectedProduk),
      ...JSON.parse(jsonNewCoveringResponse),
      ...jsonPremiData,
      emailcorrespodensi: "Y",
      ecertificate: "Y"
    }
    this.isFromDashboard = JSON.parse(localStorage.getItem('from-dashboard')!)
    this.isFromInsuredSummary = JSON.parse(localStorage.getItem('from-insured-summary') ?? "false")
    if (this.isFromDashboard) {
      this.mapNasabahToDataSpajk()
    }

    if (jsonTandaTangan != null) {
      this.tandaTangan = JSON.parse(jsonTandaTangan)
    }

    if (jsonLogin != null) {
      this.loginResponse = JSON.parse(jsonLogin);
    }

    // this.dataDummy()
    this.dobParse();
    this.isLoading = !(this.tandaTangan == null)
    window.setTimeout(() => {
      this.isLoading = false;
    }, 45000)

  }

  @Input('spajk')
  get spajk() {
    return this.dataSpajk;
  }

  backInsuredSummary() {
    this.router.navigate(['/eform/dashboard/insured-summary/' + this.dataSpajk.referenceNo + '/' + this.dataSpajk.partnerId])
  }

  continue() {
    if (this.tandaTangan && this.isRiplayDownloaded && this.isSpajkDownloaded) {
      this.isLoading = true;
      this.documentService.generateLetterBtpn({
        "refnum": this.spajk.referenceNumber,
        "memberstatus": "APPROVED"
      }).subscribe(res => {
        this.router.navigate(['eform/final'])
      })
    } else if (!this.tandaTangan) {
      this.router.navigate(['/eform/summary'])
    } else {
      alert('Mohon untuk mengunduh dokumen SPAJK dan RIPLAY Personal')
    }
  }

  getKantorCabang() {
    if (this.isFromDashboard) {
      return this.spajk.kantorCabang
    }
    else return this.spajk.kantorCabang.split("-", 2)[0];
  }

  getCharatIndex(i: any): string {
    return this.spajk.emailaddressstaff[i];
  }

  dobParse(): void {
    const dobP = this.dataSpajk.dob.split('-');
    this.dataSpajk.thn = dobP[0];
    this.dataSpajk.bln = dobP[1];
    this.dataSpajk.tgl = dobP[2];
  }

  ngAfterViewInit(): void {
    this.isLoading = false;
    if (this.tandaTangan) {
      this.isLoading = true;
      // this.sendImage()
      if (!this.isFromInsuredSummary) {
        this.newCoveringService.uploadDocument(this.dataSpajk.referenceNo, this.newCoveringService.dataURItoBlob(this.spajk.fileInput), "KTPID")
          .subscribe(res => {
            localStorage.setItem("dokumen-upload", JSON.stringify(res))
          })
      }
    }
  }

  downloadSpajk() {
    this.isLoadingSpajk = true;
    this.generatePDF(this.spajkWrapper, this.spajk.nomorAplikasi + '_SPAJK')
  }

  downloadRiplay() {
    this.isLoadingRiplay = true;
    this.generatePDF(this.riplayWrapper, this.spajk.nomorAplikasi + '_RIPLAY')
  }

  generatePDF(elementRef: ElementRef, fileType: string) {
    const doc = new jspdf();

    // Get HTML content to be converted to PDF
    const content = elementRef.nativeElement;

    // Find all elements with the page-break class
    const elements = content.getElementsByClassName('page-break');

    // Convert HTML content to PDF pages based on page-break class
    this.htmlToPDF(doc, elements, fileType);
  }

  private htmlToPDF(doc: jspdf, elements: HTMLCollectionOf<Element>, fileType: string) {
    // Options for html2canvas
    const options = {
      scale: 1.3,
      useCORS: true,  // Use CORS to handle cross-origin images
      allowTaint: true,
      logging: true,
      scrollY: 0,
    };

    // Function to recursively add pages to PDF
    const addPageRecursive = (index: number) => {
      if (index >= elements.length) {

        let blob = new Blob([doc.output('blob')], { type: 'application/pdf' })
        if (fileType.includes("SPAJK")) {
          this.newCoveringService.uploadDocument(this.spajk.referenceNumber!, blob, "SPAJK").subscribe(() => {
            doc.save("SPAJK " + this.dataSpajk.referenceNo)
            this.isSpajkDownloaded = true;
            this.isLoadingSpajk = false;
            this.isLoading = !(this.isSpajkDownloaded && this.isRiplayDownloaded)
            localStorage.setItem('download-spajk', 'true')
          })

        }
        if (fileType.includes("RIPLAY")) {
          this.newCoveringService.uploadDocument(this.spajk.referenceNumber!, blob, "RIPLAY").subscribe(() => {
            doc.save("RIPLAY " + this.dataSpajk.referenceNo)
            // let blob = new Blob([doc.output('blob')], {type: 'application/pdf'})
            this.isRiplayDownloaded = true;
            this.isLoadingRiplay = false;
            this.isLoading = !(this.isSpajkDownloaded && this.isRiplayDownloaded)
            localStorage.setItem('download-riplay', 'true')
          })
        }
        return;
      }

      const element = elements[index] as HTMLElement;

      // Use html2canvas to convert each element to canvas
      html2canvas(element, options).then((canvas) => {
        // Calculate PDF height based on the canvas height and width
        const imgWidth = 210; // PDF page width in mm (A4 size)
        const imgHeight = canvas.height * imgWidth / canvas.width; // Calculate PDF height

        // Add a new page for each element (except the first one)
        if (index > 0) {
          doc.addPage();
        }

        // Convert canvas to PDF using jsPDF
        const imgData = canvas.toDataURL('image/png');
        doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight, '', 'FAST');

        // Move to the next element recursively
        addPageRecursive(index + 1);
      }).catch((error) => {
        console.error('Error generating PDF:', error);
        // Handle errors if needed
      });
    };

    // Start adding pages from the first element
    addPageRecursive(0);
  }

  mapNasabahToDataSpajk() {
    let nasabah: NasabahModel = JSON.parse(localStorage.getItem('nasabah')!)
    let selectedItem: any = JSON.parse(localStorage.getItem('selected-item')!)

    this.dataSpajk.policynumber = nasabah.nasabahNewCovering.policyNo ?? "CL 2022 076"
    this.dataSpajk.healthQuestionFlag = nasabah.nasabahNewCovering.healthQuestionFlag
    this.dataSpajk.emailKoresponden = nasabah.nasabahNewCovering.emailCorrespondenceFlag
    this.dataSpajk.bungaPinjaman = 20
    // this.todayDate = new Date(nasabah.nasabahUw.createdDate ?? "")
    this.dataSpajk.productName = nasabah.nasabahNewCovering.productName ?? 'SMARTPROTECTION SMBCI Purnabakti'
    this.dataSpajk.productname = nasabah.nasabahNewCovering.productName ?? 'SMARTPROTECTION SMBCI Purnabakti'
    this.dataSpajk.productcode = nasabah.nasabahNewCovering.productCode ?? 'SPKTAPBTPN'
    this.dataSpajk.referenceNumber = nasabah.nasabahNewCovering.referenceNo ?? selectedItem.referenceNo
    this.dataSpajk.referenceNo = nasabah.nasabahNewCovering.referenceNo ?? selectedItem.referenceNo
    this.dataSpajk.occupation = nasabah.nasabahNewCovering.occupation ?? selectedItem.pekerjaan
    this.dataSpajk.dob = selectedItem.dob
    this.dataSpajk.entryAge = selectedItem.entryAge
    this.dataSpajk.emailKoresponden = "Y"

    this.dataSpajk.weightGainlossFlag = this.dataSpajk.healthQuestionFlag == "N" ? "N" : this.dataSpajk.weightGainlossFlag
    this.dataSpajk.smokingFlag = this.dataSpajk.healthQuestionFlag == "N" ? "N" : this.dataSpajk.smokingFlag
    // this.dataSpajk.emailKoresponden = "Y"
    // this.dataSpajk.emailKoresponden = "Y"

    //From Endorsement Mapping
    this.dataSpajk.emailaddressstaff = this.dataSpajk.emailaddressstaff ?? nasabah.nasabahNewCovering.emailaddressstaff
    this.dataSpajk.fullName = this.dataSpajk.fullName ?? nasabah.nasabahNewCovering.fullName
    this.dataSpajk.tempatLahir = this.dataSpajk.tempatLahir ?? nasabah.nasabahNewCovering.pob
    this.dataSpajk.nik = this.dataSpajk.nik ?? nasabah.nasabahNewCovering.identityNumber
    this.dataSpajk.gender = this.dataSpajk.gender ?? nasabah.nasabahNewCovering.gender
    this.dataSpajk.statusPerkawinan = this.dataSpajk.statusPerkawinan ?? nasabah.nasabahNewCovering.maritalStatus
    // this.dataSpajk.nik = this.dataSpajk.nik ?? nasabah.nasabahNewCovering.identityNumber
    // this.dataSpajk.nik = this.dataSpajk.nik ?? nasabah.nasabahNewCovering.identityNumber

    if (nasabah.nasabahNewCovering.referenceNo !== null) {
      this.dataSpajk = {
        ...this.dataSpajk,
        // uwStatus: nasabah.nasabahUw.uwStatus,
        // gender: selectedItem.gender,
        dob: selectedItem.dob.split("T")[0].toString(),
        entryAge: selectedItem.entryAge,
        pekerjaan: selectedItem.pekerjaan,
        tenure: nasabah.nasabahCalculator.tenure,
        sumAssured: nasabah.nasabahCalculator.sumAssured,
        height: nasabah.nasabahNewCovering.height ?? this.dataSpajk.height,
        weight: nasabah.nasabahNewCovering.weight ?? this.dataSpajk.weight,
        weightGainlossKg: nasabah.nasabahNewCovering.weightGainlossKg ?? this.dataSpajk.weightGainlossKg,
        weightGainlossFlag: nasabah.nasabahNewCovering.weightGainlossFlag ?? this.dataSpajk.weightGainlossFlag,
        smokingPcs: nasabah.nasabahNewCovering.smokingPcs ?? this.dataSpajk.smokingPcs,
        smokingFlag: nasabah.nasabahNewCovering.smokingFlag ?? this.dataSpajk.smokingFlag,
        // preexistingConditionFlag: this.dataSpajk.preexistingConditionFlag,
        chestPain: nasabah.nasabahNewCovering.chestPain ?? this.dataSpajk.chestPain,
        highBloodPresure: nasabah.nasabahNewCovering.highBloodPresure ?? this.dataSpajk.highBloodPresure,
        stroke: nasabah.nasabahNewCovering.stroke ?? this.dataSpajk.stroke,
        heartBloodVessel: nasabah.nasabahNewCovering.heartBloodVessel ?? this.dataSpajk.heartBloodVessel,
        bloodDisorder: nasabah.nasabahNewCovering.bloodDisorder ?? this.dataSpajk.bloodDisorder,
        leukimia: nasabah.nasabahNewCovering.leukimia ?? this.dataSpajk.leukimia,
        lungs: nasabah.nasabahNewCovering.lungs ?? this.dataSpajk.lungs,
        lymphgland: nasabah.nasabahNewCovering.lymphgland ?? this.dataSpajk.lymphgland,
        cancerTumor: nasabah.nasabahNewCovering.cancerTumor ?? this.dataSpajk.cancerTumor,
        diabetic: nasabah.nasabahNewCovering.diabetic ?? this.dataSpajk.diabetic,
        mentalDisorders: nasabah.nasabahNewCovering.mentalDisorders ?? this.dataSpajk.mentalDisorders,
        brainAbnormalities: nasabah.nasabahNewCovering.brainAbnormalities ?? this.dataSpajk.brainAbnormalities,
        stomachIntenstine: nasabah.nasabahNewCovering.stomachIntenstine ?? this.dataSpajk.stomachIntenstine,
        liver: nasabah.nasabahNewCovering.liver ?? this.dataSpajk.liver,
        drugAbuse: nasabah.nasabahNewCovering.drugAbuse ?? this.dataSpajk.drugAbuse,
        alcoholic: nasabah.nasabahNewCovering.alcoholic ?? this.dataSpajk.alcoholic,
        aidsHiv: nasabah.nasabahNewCovering.aidsHiv ?? this.dataSpajk.aidsHiv,
        pregnantFlag: nasabah.nasabahNewCovering.healthQuestionFlag == "Y" ? nasabah.nasabahNewCovering.pregnantFlag : "",
        pregnantPeriod: nasabah.nasabahNewCovering.healthQuestionFlag == "Y" ? nasabah.nasabahNewCovering.pregnantPeriod : "",
        othersFlag: nasabah.nasabahNewCovering.healthQuestionFlag == "Y" ? nasabah.nasabahNewCovering.othersFlag : "",
        othersRemark: nasabah.nasabahNewCovering.healthQuestionFlag == "Y" ? nasabah.nasabahNewCovering.othersRemark : "",
        familyHealthFlag: nasabah.nasabahNewCovering.healthQuestionFlag == "Y" ? nasabah.nasabahNewCovering.familyHealthFlag : "",
        familyHealthCondition: nasabah.nasabahNewCovering.healthQuestionFlag == "Y" ? nasabah.nasabahNewCovering.familyHealthCondition : "",
        rejectionPolicyFlag: nasabah.nasabahNewCovering.healthQuestionFlag == "Y" ? nasabah.nasabahNewCovering.rejectionPolicyFlag : "",
        rejectionPolicyHistory: nasabah.nasabahNewCovering.healthQuestionFlag == "Y" ? nasabah.nasabahNewCovering.rejectionPolicyHistory : "",
        kantorCabang: nasabah.nasabahNewCovering.branchDescription,
        // kindOfProduct: nasabah.nasabahUw.productName,
        // policynumber: nasabah.nasabahUw.se belom

      }

      if (this.dataSpajk.healthQuestionFlag == "Y") {
        this.dataSpajk.smokingFlag = nasabah.nasabahNewCovering.smokingFlag == "N" ? "" : nasabah.nasabahNewCovering.smokingFlag
        this.dataSpajk.weightGainlossFlag = nasabah.nasabahNewCovering.weightGainlossFlag == "N" ? "" : nasabah.nasabahNewCovering.weightGainlossFlag
      } else {
        this.dataSpajk.smokingFlag = "N"
        this.dataSpajk.weightGainlossFlag = "N"
      }
      // this.dataSpajk.smokingFlag = this.dataSpajk.smokingFlag == 'N' ? "" : this.dataSpajk.smokingFlag
      // this.dataSpajk.weightGainlossFlag = this.dataSpajk.weightGainlossFlag == 'N' ? "" : this.dataSpajk.weightGainlossFlag

    }
  }
}
